import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {selectRobot} from '../reducers/selected-robot';
import {closeRobotMenu} from '../reducers/menus';

import RobotSelectorComponent from '../components/robot-selector/robot-selector.jsx';

class RobotSelector extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleChange'
        ]);
    }
    handleChange (e) {
        const newRobot = e.target.value;
        sessionStorage.setItem('selected_robot', newRobot);
        this.props.onChangeRobot(newRobot);
    }
    render () {
        const {
            onChangeRobot, // eslint-disable-line no-unused-vars
            children,
            ...props
        } = this.props;
        return (
            <RobotSelectorComponent
                onChange={this.handleChange}
                {...props}
            >
                {children}
            </RobotSelectorComponent>
        );
    }
}

RobotSelector.propTypes = {
    children: PropTypes.node,
    currentRobot: PropTypes.string.isRequired,
    onChangeRobot: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    currentRobot: state.robot.cdid
});

const mapDispatchToProps = dispatch => ({
    onChangeRobot: robot => {
        dispatch(selectRobot(robot));
        dispatch(closeRobotMenu());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RobotSelector);
